import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactDOM from 'react-dom';
import './style.scss';
import { closeModal } from '../../redux/actions';

const modalRoot = document.getElementById('modal-root');

function Modal({ children }) {
	const { isOpen, content, closeBtn, onCloseCallback } = useSelector((state) => state.modal);
	const { apiError } = useSelector((state) => state.app);
	const dispatch = useDispatch();
	const wrapperRef = useRef(null);

	const handleWrapperClick = (e) => {
		if (e.target !== wrapperRef.current || !!apiError) return;
		onCloseCallback && onCloseCallback();
		dispatch(closeModal());
	};

	return (
		isOpen &&
		ReactDOM.createPortal(
			<div className={`modal-wrapper`} onClick={handleWrapperClick} ref={wrapperRef}>
				<div className={`modal-box`}>
					{closeBtn && (
						<button
							className="modal-close-btn"
							onClick={() => {
								onCloseCallback && onCloseCallback();
								dispatch(closeModal());
							}}
						/>
					)}
					{children || content}
				</div>
			</div>,
			modalRoot
		)
	);
}

export default Modal;
